import axioPath from "api/axioPath";
import { UPDATE_DATA } from "redux/actions/action_types";

export const palletDetails = (token) => (dispatch) => {
  return axioPath.get("/order/get_specification", {
    headers: {
      Authorization: `${token}`,
      UserType: "external"
    },
  })
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data, apiType: "form" });
      return { error: false, data: response.data };
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};

export const uploadSpectFile = (formData, token) => (dispatch) => {
  return axioPath
    .post("/s3/upload_file", formData, {
      headers: {
        Authorization: `${token}`,
        UserType: "external",
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return { error: false, data: response.data };
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};
export const createOrder = (date, token) => (dispatch) => {
  return axioPath
    .post("/order/create", date, {
      headers: {
        Authorization: `${token}`,
        UserType: "external",
      },
    })
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return { error: false, data: response.data };
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};
export const updateOrder = (data, token) => (dispatch) => {
  return axioPath
    .post("/order/update/requested_order", data, {
      headers: {
        Authorization: `${token}`,
        UserType: "external",
      },
    })
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return { error: false, data: response.data };
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};
export const orderRefNumber = (orderRefNumber, token) => (dispatch) => {
  return axioPath
    .get("/order/order_ref_number/" + orderRefNumber, {
      headers: {
        Authorization: `${token}`,
        UserType: "external",
      },
    })
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return { error: false, data: response.data };
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};
export const locationList = (locType, customerId, token) => (dispatch) => {
  return axioPath.get(`/internal/locations/${customerId}/list/${locType}`, {
    headers: {
      Authorization: `${token}`,
      UserType: "external",
    },
  }).then((response) => {
    dispatch({ type: UPDATE_DATA, payload: response.data, apiType: "form" });
    return { error: false, data: response.data };
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};
export const pickupLocationList = (locType, customerId, token) => (dispatch) => {
  return axioPath.get(`/internal/pickup_location/${customerId}/list/${locType}`, {
    headers: {
      Authorization: `${token}`,
      UserType: "external",
    },
  })
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data, apiType: "form" });
      return { error: false, data: response.data };
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};